import { FC } from 'react';
import styled from 'styled-components';

import { useSecureJsonCollectionsStore } from '@/shared/lib/sj-orm/stores/secureJsonCollections.store';
import { useSyncQueueStore } from '@/shared/lib/sj-orm/synchronizer/sync-queue.store';

export const DebugButton: FC<{ onClick: () => void }> = ({ onClick }) => {
  const sjcStore = useSecureJsonCollectionsStore();
  const syncQueueStore = useSyncQueueStore();
  const className = [
    sjcStore.operations.length > 0 ? 'hasoperations' : '',
    syncQueueStore.jobs.length > 0 ? 'hasjobs' : '',
  ].join(' ');

  return (
    <Container className={className} onClick={onClick}>
      D
    </Container>
  );
};

const Container = styled.div`
  z-index: var(--zindex-appdebug, 999999);
  position: fixed;
  left: 4px;
  top: 4px;

  width: 32px;
  height: 32px;
  border-radius: 8px;

  display: flex;
  align-items: center;
  justify-content: center;

  box-shadow: 0 0 4px 0 black;
  background: rgba(255, 255, 255, 0.9);
  cursor: pointer;

  &&&.hasoperations::before,
  &&&.hasjobs::before {
    position: absolute;
    top: -1px;
    right: -1px;
    content: '';
    display: block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    border: 1px white solid;
    background: rgba(0, 0, 0, 1);
  }

  &&&.hasjobs::before {
    background: rgba(255, 165, 0, 1);
  }

  &&&.hasoperations::before {
    background: rgba(255, 64, 64, 1);
  }
`;
